import React from "react";
import loadable from "@loadable/component";

import SplashText from "../../components/SplashText";
import { Section, Heading, ProjectList } from "./styles";
import ProjectCardsSkeleton from "./project-card-skeleton";

const ProjectCards = loadable(() => import("./project-card"));

const ProjectsSection = ({ compensateHeaderGap = false }) => {
  return (
    <Section
      name="projects"
      as="section"
      $compensateHeaderGap={compensateHeaderGap}
    >
      <Heading as={compensateHeaderGap ? "h1" : "h2"}>
        <SplashText variant="accent">Projects</SplashText>
      </Heading>
      <ProjectList>
        <ProjectCards fallback={<ProjectCardsSkeleton />} />
      </ProjectList>
    </Section>
  );
};

export default ProjectsSection;
